import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRight, Sparkles, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function CtaBand() {
    return (
        <section data-testid="home-cta-band" className="relative py-20 lg:py-24">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 14 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="dt-neon-border"
                >
                    <div className="dt-neon-inner relative overflow-hidden rounded-[var(--radius)] p-8 sm:p-12 lg:p-16">
                        <div className="absolute -top-16 -right-12 h-72 w-72 rounded-full bg-[radial-gradient(closest-side,rgba(0,229,255,0.18),transparent)] pointer-events-none" />
                        <div className="absolute -bottom-24 -left-16 h-96 w-96 rounded-full bg-[radial-gradient(closest-side,rgba(72,255,175,0.12),transparent)] pointer-events-none" />
                        <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
                            <div className="lg:col-span-8">
                                <span className="dt-section-eyebrow">
                                    <Sparkles className="h-3.5 w-3.5" /> TURN STRATEGY INTO WORKING SYSTEMS
                                </span>
                                <h2 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight">
                                    Ready to solve your highest-value <span className="dt-gradient-text">digital challenge</span>?
                                </h2>
                                <p className="mt-3 text-foreground/80 max-w-2xl leading-relaxed">
                                    Whether you are modernising an institution, building mission-critical software, launching an intelligent product, connecting fragmented systems, or scaling a digital venture, DigiTech Cloud AI can help turn your vision into dependable execution.
                                </p>
                            </div>
                            <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-3">
                                <Button
                                    asChild
                                    size="lg"
                                    className="bg-primary text-primary-foreground hover:bg-primary/90 shadow-[0_0_0_1px_rgba(0,229,255,0.35),0_0_28px_rgba(0,229,255,0.22)]"
                                    data-testid="cta-band-primary-button"
                                >
                                    <Link to="/contact" className="inline-flex items-center gap-1.5">
                                        Book a Consultation <ArrowUpRight className="h-4 w-4" />
                                    </Link>
                                </Button>
                                <Button
                                    asChild
                                    size="lg"
                                    variant="secondary"
                                    className="bg-secondary text-secondary-foreground border border-white/10 hover:border-primary/50"
                                >
                                    <Link to="/services" className="inline-flex items-center gap-1.5">
                                        Explore Our Capabilities <ArrowRight className="h-4 w-4" />
                                    </Link>
                                </Button>
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
